<template>
  <div class="flex shrink grow justify-center gap-0.5 pr-1">
    <AnnouncementBanner
      v-if="maintenance"
      :announcement="maintenance"
      @hide-announcement="hide"
      :compact="news != undefined"
      @animated="animated"
    />
    <AnnouncementBanner
      v-if="news"
      :announcement="news"
      @hide-announcement="hide"
      :compact="maintenance != undefined"
      @animated="animated"
    />
  </div>
</template>

<script lang="ts" setup>
  import { storeToRefs } from 'pinia'
  import { useNotificationStore } from '../../../stores/notification.store'
  import AnnouncementBanner from './AnnouncementBanner.vue'

  const notificationStore = useNotificationStore()
  const { news, maintenance } = storeToRefs(notificationStore)
  const { hide, animated } = notificationStore
</script>
